module.exports = __webpack_public_path__ + "img/ticket.c77ae1ec.svg";